export default "__VITE_ASSET__DinhQdTP__"